/**
 * GradientNavBar
 * Created by zhangdanyang5 on 2018/11/05.
 */
import React, { PureComponent } from 'react';
import {
    Animated
} from 'react-native';

import LinearGradient from '@jdreact/jdreact-core-linear-gradient';

import NavBar from '../nav-bar';
// import st from './style';

/**
 * @param progress 滚动进度
 * @param onLayout 用于父组件获取定位
 * @param onRefNavBar 用于父组件调用子组件（NavBar）的方法
 * @param navBarProps 子组件 NavBar 属性
 */
export default class GradientNavBar extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        /* 展示的状态条 navType  透明底白按钮 (0)/ 红底黑按钮 (1) */
        const { navType, onLayout, onRefNavBar, navBarProps } = this.props;

        return (
            <Animated.View
                onLayout={ onLayout }
                ref={ e => { this.ref = e; } }
            >
                {navType === 0 &&
                    <LinearGradient start={ { x: 0, y: 0 } } end={ { x: 0, y: 1 } } colors={ ['rgba(0,0,0,0.7)', 'rgba(0,0,0,0)'] } style={ { position: 'absolute', left: 0, right: 0, top: 0, bottom: 0 } } />
                }
                {navType === 1 &&
                    <LinearGradient start={ { x: 0, y: 0 } } end={ { x: 1, y: 0 } } colors={ ['#FC635E', '#FC655E', '#FD5665'] } style={ { position: 'absolute', left: 0, right: 0, top: 0, bottom: 0 } } />
                }
                <NavBar
                    onRefNavBar={ onRefNavBar }
                    titleBgColor={ 'transparent' }
                    { ...navBarProps }
                    gradientNavBar={ true }
                    title={ '' }
                    barStyle={ 'light-content' }
                />
            </Animated.View>
        );
    }

    componentDidMount() {
        this.props.onRefGradientNavBar && this.props.onRefGradientNavBar(this);
    }

    setOpacity(opacity) {
        this.ref.setNativeProps({
            style: { opacity }
        });
    }
}
